module.exports = __webpack_public_path__ + "static/media/logo.b91178b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/precatorios-brasil/logo.svg
// module id = 479
// module chunks = 2